<form class="example-form">
	<input type="text"
		#input="matAutocompleteTrigger"
		[ngClass]="inputClass"
		[formControl]="inputControl"
		[matAutocomplete]="dropdownlist"
		[matAutocompletePosition]="'below'"
		[attr.disabled]="disabled ? true : null"
		(focus)="onInputFocus()"
		/>
		
	<mat-autocomplete 
		#dropdownlist="matAutocomplete"
		[class]="panelClass"
		>
		
        <mat-option *ngIf="isLoading" [disabled]="true" class="info-option">Chargement des suggestions...</mat-option>
        <ng-container *ngIf="!isLoading">
	        <mat-option [disabled]="true" *ngIf="inputControl.value" class="info-option">Correspondances possibles: {{ suggestionsCount }}</mat-option>
			<mat-option
				*ngFor="let suggestion of suggestions"
				[value]="suggestion"
				>

				{{ suggestion }}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>